import React, { useMemo } from 'react'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'
import { SelectInput } from '@/modules/base/components/inputs'
import { COMPANY_FORM_AG, COMPANY_FORM_EK, COMPANY_FORM_FREELANCER, COMPANY_FORM_SOLE_TRADER, COMPANY_FORM_GBR, COMPANY_FORM_GMBH_COKG, COMPANY_FORM_KG, COMPANY_FORM_OHG, COMPANY_FORM_OTHER_COMPANY, COMPANY_FORM_OTHER_PARTNERSHIP, COMPANY_FORM_SILENT, COMPANY_FORM_TRADER, COMPANY_FORM_UG, COMPANY_FORM_GMBH, COMPANY_FORM_PERSON, COMPANY_FORM_LEGAL_FOUNDATION, COMPANY_FORM_CHARITABLE_FOUNDATION } from '@/modules/client/constants'
import RichTooltip from '@/modules/base/components/rich-tooltip/rich-tooltip'
import clsx from 'clsx'
const {
  companyForm,
} = lang.createClient

const CompanyFormInput = (props) => {
  const { useFormik, name = 'legalFormNames', wrapperClassName = null } = props
  const classes = useStyles()

  const options = [
    { value: COMPANY_FORM_PERSON, label: companyForm.person },
    { value: COMPANY_FORM_EK, label: companyForm.ek },
    { value: COMPANY_FORM_TRADER, label: companyForm.trader },
    { value: COMPANY_FORM_FREELANCER, label: companyForm.freelancer },
    { value: COMPANY_FORM_SOLE_TRADER, label: companyForm.sole_trader },
    { value: COMPANY_FORM_GBR, label: companyForm.gbr },
    { value: COMPANY_FORM_OHG, label: companyForm.ohg },
    { value: COMPANY_FORM_KG, label: companyForm.kg },
    { value: COMPANY_FORM_GMBH_COKG, label: companyForm.gmbh_cokg },
    { value: COMPANY_FORM_SILENT, label: companyForm.silent },
    { value: COMPANY_FORM_OTHER_PARTNERSHIP, label: companyForm.other_partnership },
    { value: COMPANY_FORM_UG, label: companyForm.ug },
    { value: COMPANY_FORM_GMBH, label: companyForm.gmbh },
    { value: COMPANY_FORM_AG, label: companyForm.ag },
    { value: COMPANY_FORM_LEGAL_FOUNDATION, label: companyForm.legalFoundation },
    { value: COMPANY_FORM_CHARITABLE_FOUNDATION, label: companyForm.charitableFoundation },
    { value: COMPANY_FORM_OTHER_COMPANY, label: companyForm.other_company },
  ]

  const tooltipContent = useMemo(() => (<div className={classes.tooltipWrapper}>
    <div className={classes.tooltipTitle}>{lang.settings.taxes.companyFormInputTooltipHeader}</div>
    <div className={classes.tooltipContent}>{lang.settings.taxes.companyFormInputTooltipDescription1}</div>
  </div>
  ), [])

  return (
    <>
      <RichTooltip content={tooltipContent} width={360} placement={'left'}>
        <div className={clsx(classes.contentWrapper, wrapperClassName)}>
          <SelectInput
            name={name}
            className={classes.companyFormInput}
            useFormik={useFormik}
            notAsync
            allowCreate={false}
            label={lang.settings.taxes.companyFormInput}
            options={options}
            customSelectOptions={{
              placeholder: lang.settings.taxes.companyFormInputPlaceholder,
            }}
          />
        </div>
      </RichTooltip>
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  contentWrapper: {
    width: '50%',
    paddingBottom: '20px',
    paddingRight: '25px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingRight: 0,
    },
  },
  companyFormInput: {
    width: '100%',
  },
  tooltipWrapper: {
    height: 'fit-content',
    color: theme.black,
  },
  tooltipTitle: {
    paddingBottom: '20px',
    textAlign: 'center',
    fontSize: theme.fontSizes.default,
    lineHeight: '20px',
    color: theme.black,
    fontWeight: theme.fontWeights.bold,
  },
  tooltipContent: {
    fontSize: theme.fontSizes.smaller,
    marginTop: 10,
  },
}))

export default CompanyFormInput
